module.exports = __webpack_public_path__ + "static/media/iep-thumb-cvs.5270acbe.jpg";